export default {
  mixed: {
    required: 'Ce champ est obligatoire',
    default: 'Champ invalide'
  },
  string: {
    min: ({ min }) => `Ce champ doit contenir au moins ${min} caractères`,
    max: ({ max }) => `Ce champ doit contenir au plus ${max} caractères`,
    email: 'Veuillez saisir une adresse e-mail valide'
  },
  number: {
    min: ({ min }) => `Ce champ doit être au moins ${min}`,
    max: ({ max }) => `Ce champ doit être au plus ${max}`
  }
}
